import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import { toast } from "react-toastify";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const { user } = useAuth();
  const userId = user?._id;

  const [cart, setCart] = useState([]);

  // Load cart when user changes
  useEffect(() => {
    if (userId) {
      const storedCart = localStorage.getItem(`cart_${userId}`);
      setCart(storedCart ? JSON.parse(storedCart) : []);
    } else {
      setCart([]);
    }
  }, [userId]);

  // Save cart
  useEffect(() => {
    if (userId) {
      localStorage.setItem(`cart_${userId}`, JSON.stringify(cart));
    }
  }, [cart, userId]);

  const addToCart = (product) => {
    if (!userId) {
      toast.error("Please login first 🔐");
      return;
    }

    setCart((prev) => {
      const exists = prev.find((item) => item._id === product._id);

      if (exists) {
        toast.info("Quantity Updated 🛒");
        return prev.map((item) =>
          item._id === product._id
            ? { ...item, qty: item.qty + 1 }
            : item
        );
      }

      toast.success("Added to Cart ✅");
      return [...prev, { ...product, qty: 1 }];
    });
  };

  const removeFromCart = (id) => {
    setCart((prev) => {
      toast.warning("Removed from Cart ❌");
      return prev.filter((item) => item._id !== id);
    });
  };

  const cartCount = cart.length;

  return (
    <CartContext.Provider
      value={{ cart, addToCart, removeFromCart, cartCount }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
